import { ref, reactive, watch } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2bac072f"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "wechat-content"
};
const _hoisted_2 = {
  class: "flex-content"
};
const _hoisted_3 = {
  class: "flex-list",
  style: {
    "justify-content": "flex-start"
  }
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "notice-text"
}, [/*#__PURE__*/_createTextVNode(" https:// "), /*#__PURE__*/_createElementVNode("span", null, "pay.wedobest.com.cn:8449"), /*#__PURE__*/_createTextVNode(" /PayServer/wx/ios/msg ")], -1));
const _hoisted_5 = {
  class: "notice-desc"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "https://pm.wedobest.com.cn:8469/#/domainManage"
}, "产品中台-域名管理", -1));
const __default__ = {
  name: 'WechatJsApiPay'
};
import SvgIcon from '@/components/SvgIcon.vue';
import { copy } from '@/common';
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    rules: {},
    detailForm: {}
  },
  emits: ['submitForm'],
  setup(__props, {
    expose,
    emit
  }) {
    const props = __props;
    const jsApiRef = ref(null); // 微信jsApi支付ref
    const jsApiForm = reactive({
      divide: '100%',
      appId: '',
      mchId: null,
      apiKey: '',
      mchName: '',
      merchants: '',
      wxPriKey: '',
      apiKeyV3: '',
      certSerialNo: '',
      pkg: '',
      rate: 0.009
    }); // 微信jsApi支付
    const channelRateList = ref([]); // 费率列表
    const validateForm = () => {
      var _jsApiRef$value;
      (_jsApiRef$value = jsApiRef.value) === null || _jsApiRef$value === void 0 || _jsApiRef$value.validate().then(() => {
        emit('submitForm', jsApiForm);
      }).catch(e => void 0);
    };
    watch(() => props.detailForm, n => {
      if (n) {
        jsApiForm.pkg = n.pkg;
        jsApiForm.appId = n.appId;
        jsApiForm.mchName = n.mchName;
        jsApiForm.merchants = n.merchants;
        jsApiForm.apiKeyV3 = n.apiKeyV3;
        jsApiForm.certSerialNo = n.certSerialNo;
        jsApiForm.wxPriKey = n.wxPriKey;
        channelRateList.value = n.channelRateList;
        jsApiForm.rate = n.channelRate;
      }
    }, {
      immediate: true,
      deep: true
    });
    expose({
      validateForm
    });
    return (_ctx, _cache) => {
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_form = _resolveComponent("a-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_form, {
        model: jsApiForm,
        ref_key: "jsApiRef",
        ref: jsApiRef,
        rules: __props.rules,
        name: "jsApi-validate"
      }, {
        default: _withCtx(() => [_createVNode(_component_a_form_item, {
          name: "pkg",
          label: "包名："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: jsApiForm.pkg,
            "onUpdate:value": _cache[0] || (_cache[0] = $event => jsApiForm.pkg = $event),
            valueModifiers: {
              trim: true
            },
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "appId",
          label: "AppID："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: jsApiForm.appId,
            "onUpdate:value": _cache[1] || (_cache[1] = $event => jsApiForm.appId = $event),
            valueModifiers: {
              trim: true
            },
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "mchName",
          label: "商户主体："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: jsApiForm.mchName,
            "onUpdate:value": _cache[2] || (_cache[2] = $event => jsApiForm.mchName = $event),
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "merchants",
          label: "商户号："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_select, {
            value: jsApiForm.merchants,
            "onUpdate:value": _cache[3] || (_cache[3] = $event => jsApiForm.merchants = $event),
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "apiKeyV3",
          label: "API key V3："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: jsApiForm.apiKeyV3,
            "onUpdate:value": _cache[4] || (_cache[4] = $event => jsApiForm.apiKeyV3 = $event),
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "certSerialNo",
          label: "证书序列号："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: jsApiForm.certSerialNo,
            "onUpdate:value": _cache[5] || (_cache[5] = $event => jsApiForm.certSerialNo = $event),
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "wxPriKey",
          label: "wx_pri_key："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: jsApiForm.wxPriKey,
            "onUpdate:value": _cache[6] || (_cache[6] = $event => jsApiForm.wxPriKey = $event),
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "rate",
          label: "费率："
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_a_select, {
            value: jsApiForm.rate,
            "onUpdate:value": _cache[7] || (_cache[7] = $event => jsApiForm.rate = $event),
            options: channelRateList.value
          }, null, 8, ["value", "options"]), _createVNode(_component_a_tooltip, {
            placement: "right"
          }, {
            title: _withCtx(() => [_createTextVNode("使用微信支付功能将收取0.9%手续费")]),
            default: _withCtx(() => [_createVNode(SvgIcon, {
              "icon-class": "questionMark",
              "class-name": "question-icon"
            })]),
            _: 1
          })])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "回调地址："
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createVNode(_component_a_tooltip, null, {
            title: _withCtx(() => [_createTextVNode("复制")]),
            default: _withCtx(() => [_createVNode(SvgIcon, {
              "icon-class": "copy",
              "class-name": "copy-icon",
              onClick: _cache[8] || (_cache[8] = $event => _unref(copy)('https://pay.wedobest.com.cn:8449/PayServer/wx/ios/msg'))
            })]),
            _: 1
          })]), _createElementVNode("div", _hoisted_5, [_createTextVNode(" 请复制该链接，按 "), _hoisted_6, _createTextVNode(" 中对应域名组的pay业务对应的域名，替换链接标红部分；并配置到微信公众平台-开发管理-消息推送-消息服务器配置； "), _createVNode(_component_a_button, {
            class: "img-btn",
            type: "link",
            onClick: _cache[9] || (_cache[9] = $event => emit('setVisible', true))
          }, {
            default: _withCtx(() => [_createTextVNode("图片指引")]),
            _: 1
          })])]),
          _: 1
        })]),
        _: 1
      }, 8, ["model", "rules"])]);
    };
  }
});